var map = {
	"./buttons.json": 85,
	"./buttons@2x.json": 86
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;


//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/buttons.*\.json$
// module id = 110
// module chunks = d-game